import type { BreadcrumbItem } from '@/cms/fields/types/common'
import { useCMSPageField } from '@/cms/fields'
import { Button } from '@sunwebgroup/uds-ui/button'
import { Icon } from '@sunwebgroup/uds-ui/icon'
import { Typography } from '@sunwebgroup/uds-ui/typography'
import styles from './BreadcrumbInFooter.module.css'

interface BreadcrumbProps {
  items?: BreadcrumbItem[]
}

export default function BreadcrumbInFooter({ items }: BreadcrumbProps) {
  const data = useCMSPageField('Breadcrumb.elements')
  let elements: BreadcrumbItem[] = []

  if (!items && !data) {
    return
  }

  if (items) {
    elements = items
  }

  if (!items && data) {
    elements = data.map(item => ({
      text: item.text,
      href: item.href,
    }))
  }

  return (
    <div className={styles.wrapper}>
      <ol className={styles.list} itemScope itemType="http://schema.org/BreadcrumbList" aria-label="Breadcrumb">
        {elements.map((item, index) => (
          <li itemProp="itemListElement" itemScope itemType="http://schema.org/ListItem" key={index}>
            <Button itemProp="item" href={item.href} as="a" variant="transparentNeutral" size="XS">
              {elements.length - 1 === index
                ? (
                    <Typography className={styles.buttonTypography} variant="body-s-regular-flat" as="span" itemProp="name" aria-current="page">
                      {item.text}
                    </Typography>
                  )
                : (
                    <>
                      <Typography className={styles.buttonTypography} variant="body-s-regular-flat" as="span" itemProp="name">
                        {item.text}
                      </Typography>
                      <Icon glyph="ChevronRightExtraSmall" size={20} />
                    </>
                  )}
            </Button>
            <meta itemProp="position" content={`${index + 1}`} />
          </li>
        ))}
      </ol>
      <div className={styles.line} />
    </div>
  )
}
